import React from "react";
import { useTranslation } from "react-i18next";

interface PageSizeSelectProps {
  value: number;
  onChange: (size: number) => void;
  options?: number[];
}

const PageSizeSelect: React.FC<PageSizeSelectProps> = ({
  value,
  onChange,
  options = [1, 10, 20, 30, 40],
}) => {
  const { t } = useTranslation();
  
  return (
    <ul className="list-inline me-auto my-1 ms-4">
      <li className="list-inline-item">
        <select
          className="form-select"
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </li>
      <span> {t("general.entriesPerPage")}</span>
    </ul>
  );
};

export default PageSizeSelect;
